import React, { useEffect, useState } from "react";
// Shared components
import Button from "components/Button";
// UI Frameworks
import { Col, Form, Icon, Modal, Row, Spin, Typography } from "antd";
// Hooks and utils
import TicketService from "services/http/endpoints/tickets";
import styles from "screens/Dashboard/screens/Tickets/index.module.scss";
import Messenger from "../messages/Messenger";

const { Title } = Typography;

type IProps = Record<string, any>;

const ShowTicket: React.FC<IProps> = props => {
	const { id } = props.match.params;
	const [loading, setLoading] = useState(true);
	const [loadingTicket, setLoadingTicket] = useState(false);
	const [ticket, setTicket] = useState<Record<string, any>>({});
	const [closed, setClose] = useState(false);
	const [messages, setMessages] = useState<Record<string, any>[]>([]);
	const [onModal, setOnModal] = useState(false);
	const [cancelHover, setCancelHover] = useState(false);

	const sendMessage = async (text: string) => {
		const sendingData = {
			body: text,
			bodyType: "TEXT",
			ticket: id,
		};
		try {
			await TicketService.sendMsg(sendingData)
				.then(res => {
					setMessages(res.data);
				})
				.catch(err => console.log("error in sending message"));
		} catch (error) {
			setLoading(true);
		}
	};

	const closeTicket = () => {
		setLoadingTicket(true);
		TicketService.close(id)
			.then(() => {
				setClose(true);
				setLoadingTicket(false);
				setOnModal(false);
			})
			.catch(() => console.log("تیکت بسته نشد. دوباره تلاش کنید!"));
	};



	useEffect(() => {
		const onLoadTicket = async () => {
			TicketService.clearOrder();
			TicketService.clearFilter();
			TicketService.page = 1;
			TicketService.size = 1;
			TicketService.makeFilters("id", "eq", id);
			const res = await TicketService.search(TicketService.getSearchFilter());
			setTicket(res.data.result[0])
		}
		onLoadTicket();
	}, [id]);

	useEffect(() => {
		const loadMessages = async () => {
			try {
				await TicketService.loadMsg(id)
					.then(res => {
						setMessages(res.data);
						setLoading(false);
					})
					.catch(err => console.log("error in retrieving messages"));
			} catch (error) {
				setLoading(true);
			}
		};
		loadMessages();
	}, [loading, id]);

	return (
		<div className="container">
			{onModal ? (
				<Modal
					title="بستن تیکت"
					visible={onModal}
					onCancel={() => setOnModal(false)}
					onOk={() => closeTicket()}
					footer={[
						<Button key="submit" type="primary" onClick={() => closeTicket()}>
							بله
						</Button>,
						<Button
							key="back"
							style={{ backgroundColor: cancelHover ? "#b36320" : "#ce7d38" }}
							onMouseLeave={() => setCancelHover(false)}
							onMouseEnter={() => setCancelHover(true)}
							onClick={() => setOnModal(false)}
						>
							نه
						</Button>,
					]}
				>
					<p>آیا میخواهید تیکت را ببندید؟</p>
				</Modal>
			) : null}
			<div className={styles["tickets"]}>
				{Object.keys(ticket).length === 0 ? (
					<span
						style={{
							width: "100%",
							height: "100%",
							display: "flex",
							position: "relative",
							justifyContent: "center",
						}}
					>
						<Spin tip="در حال بارگزاری" size="large" />
					</span>
				) : (
					<>
						<Title level={4}>
							<Icon type="tag" />
							{ticket.title}
						</Title>
						<Form>
							<Row>
								<Col span={24}>
									<Form.Item>
										<div>
											<label htmlFor="دسته بندی">دسته بندی: {ticket.category}</label>
										</div>
									</Form.Item>
									<Form.Item className="button-center">
										{ticket.status === 'CLOSED' || closed ? (
											<Button htmlType="submit" primary disabled>
												بسته
											</Button>
										) : (
											<Button
												htmlType="submit"
												primary
												loading={loadingTicket}
												onClick={() => setOnModal(true)}
											>
												بستن تیکت
											</Button>
										)}
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item label="پیام ها">
										{loading ? (
											<span
												style={{
													width: "100%",
													display: "flex",
													position: "relative",
													justifyContent: "center",
												}}
											>
												<Spin tip="در حال بارگزاری پیام ها" size="large" />
											</span>
										) : (
											<Messenger sendMessage={sendMessage} messages={messages} />
										)}
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</>
				)}
			</div>
		</div>
	);
};

export default ShowTicket;
